import HeypsterGifSDK from 'heypster-gif';

const url = window.location.href;
let version = 'v1';
let lang = 'en'
if (url.includes("v2")) {
    version = 'v2';
}

if (url.includes("/fr/")) {
    lang = 'fr';
}

let heypsterSDK = new HeypsterGifSDK('98PO-SD58-B984-X451-TR87', true, lang, 'top', version);
setTimeout(() => {
    heypsterSDK.togglePopup();

    const element = document.querySelector("#heypster-popup-overlay");
    const target = document.querySelector(".home_column_2");

    if (element && target) {
        target.appendChild(element);
    }

}, 250);



